import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Storefront/customer instance — attaches the customer token
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tamashii_customer_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Admin instance — attaches the admin token
export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("tamashii_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// CiNC (fabric inventory) admin instance — attaches the CiNC admin token
export const cincApi = axios.create({ baseURL: API });
cincApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("cinc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
